import React from "react";

const Footer = () => {
  return (
    <></>
    // <div className="bg-primary py-3 text-white px-5 text-center">
    //   © 2024. QUICKFEET All rights reserved.
    // </div>
  );
};

export default Footer;
